<template>
  <div class="subjective-glyph-container">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div v-if="info!=-1"  v-bind="attrs" v-on="on" class="subjective-glyph">
          <div class="subjective-valence"><div :class="getClass(info, 'first', type, displayOnly)"><span v-html="getSymbol(info, 'first', displayOnly)"></span></div></div>
          <div class="subjective-valence"><div :class="getClass(info, 'second', type, displayOnly)"><span v-html="getSymbol(info, 'second', displayOnly)"></span></div></div>
        </div>
      </template>
      <span>{{getPhrase(info, displayOnly)}}</span>
    </v-tooltip>
  </div>
</template>

<script>
  export default {
    props: {
      info: {
        type: Number,
        required: false
      },
      scale: {
        type: Number,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      // use 'start' or 'end' to force only half the glyph to render - defaults to 'none' where the entire glyph is rendered
      displayOnly: {
        type: String,
        required: false,
        default: 'none'
      },
      scInsightMetric: {
        type: Number,
        required: false,
      },
      scInsightChannel: {
        type: Number,
        required: false,
      },
      scLocationBeginning: {
        type: Boolean,
        required: false,
      },
      scGlyph: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data: () => ({
    }),
    computed: {
      bottomPadding() {
        // 1.2 rem is normal - larger scale requires smaller 'rem' bottom padding
        return String((.5 / (this.scale/100))) + "rem"
      }
    },
    methods: {
      getClass(val, portion, type, displayOnly) {
        if (portion == 'first' && (displayOnly == 'start' || displayOnly == 'none')) {
          switch(val) {
            case 0:
            case 1:
            case 2:
              return type + '-negative'
            case 3:
            case 4:
            case 5:
              return type + '-neutral'
            case 6:
            case 7:
            case 8:
              return type + '-positive'
          }
        } else if(portion == 'second' && (displayOnly == 'end' || displayOnly == 'none')) {
          switch(val) {
            case 0:
            case 3:
            case 6:
              return type + '-negative'
            case 1:
            case 4:
            case 7:
              return type + '-neutral'
            case 2:
            case 5:
            case 8:
              return type + '-positive'
          }
        } else {
          return 'blank'
        }
      },
      getSymbol(val, portion, displayOnly) {
        if (portion == "first") {
           switch(val) {
            case 0:
            case 1:
            case 2:
              if (displayOnly=="start"||displayOnly=='none') return '-'
              else  return '&nbsp;'
            case 3:
            case 4:
            case 5:
              if (displayOnly=="start"||displayOnly=='none') return '•'
              else  return '&nbsp;'
            case 6:
            case 7:
            case 8:
              if (displayOnly=="start"||displayOnly=='none') return '+'
              else  return '&nbsp;'
          }
        } else if (portion == 'second') {
          switch(val) {
            case 0:
            case 3:
            case 6:
              if (displayOnly=="end"||displayOnly=='none') return '-'
              else  return '&nbsp;'
            case 1:
            case 4:
            case 7:
              if (displayOnly=="end"||displayOnly=='none') return '•'
              else  return '&nbsp;'
            case 2:
            case 5:
            case 8:
              if (displayOnly=="end"||displayOnly=='none') return '+'
              else  return '&nbsp;'
          }
        }
      },
      getPhrase(info, displayOnly) {
        let phrase = ''
        let ps = ""
        let pe = ""
        if (info==0) {
          ps = "started negative"
          pe = "ended negative"
        }
        else if (info==1) {
          ps = "started negative"
          pe = "ended neutral"
        }
        else if (info==2) {
          ps = "started negative"
          pe = "ended positive"
        }
        else if (info==3) {
          ps = "started neutral"
          pe = "ended negative"
        }
        else if (info==4) {
          ps = "started neutral"
          pe = "ended neutral"
        }
        else if (info==5) {
          ps = "started neutral"
          pe = "ended positive"
        }
        else if (info==6) {
          ps = "started positive"
          pe = "ended negative"
        }
        else if (info==7) {
          ps = "started positive"
          pe = "ended neutral"
        }
        else if (info==8) {
          ps = "started positive"
          pe = "ended positive"
        }
        if(displayOnly!='none') {
          if (this.scGlyph) return this.scorecardPhrase()
          if(displayOnly == 'start') phrase = "Call " + ps
          else if(displayOnly == 'end') phrase = "Call " + pe
        } else phrase = "Call " + ps + " and " + pe
        return phrase
      },
      scorecardPhrase() {
        let scString = this.type.charAt(0).toUpperCase() + this.type.slice(1)
        let locationText = this.scLocationBeginning ? " Beginning " : " Ending "
        switch (this.scInsightChannel) {
          case 0:
            return "Agent " + locationText + scString 
          case 1:
            return "Customer " + locationText + scString 
          default:
            return "Overall " + locationText + scString 
        }
      },
    }
  }
</script>

<style scoped>

  .subjective-glyph-container { min-height: 50px; display: table; width: 100%; height: 100%; margin-top: 1rem; }
  .subjective-glyph { margin-top: .75rem; min-width: 5rem;}
  .subjective-valence { aspect-ratio: 1/1; display: inline-block; min-height: 1.3rem; text-align: center; }
  .subjective-valence div { font-size: 1rem; font-weight: bold; color: rgba(255,255,255,1); vertical-align: text-bottom; border-radius: 3px; min-width:25px; }
  .emotion-positive { background-color: rgb(183, 189, 77); }
  .emotion-neutral { background-color: rgba(194, 194, 194, 1); }
  .emotion-negative { background-color: rgba(205, 95, 9, 1); }
  .sentiment-positive { background-color: rgba(140, 199, 63, 1); }
  .sentiment-neutral { background-color: rgba(184, 184, 184, 1); }
  .sentiment-negative { background-color: rgba(179, 63, 38, 1); }
  .blank { background-color: rgba(0, 0, 0, .025); border: 1px rgba(0, 0, 0, .1) solid;  }
</style>
